/* ============================================================
   きもの永見 モバイル用スティッキーフッターCTAバー
   ファイル: assets/sticky-footer.js
   機能（シンプル版）:
   1. カート点数の動的更新
   2. GA4イベント計測
   ============================================================ */

(function () {
  'use strict';

  if (!window.matchMedia('(max-width: 749px)').matches) return;

  var footer = document.querySelector('.kn-sticky-footer');
  if (!footer) return;

  var badge = footer.querySelector('[data-kn-cart-count]');

  // ============================================================
  // 1. カート点数の動的更新
  // ============================================================
  function updateCartCount() {
    if (!badge) return;
    fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var count = cart && typeof cart.item_count === 'number' ? cart.item_count : 0;
        if (count > 0) {
          badge.textContent = count;
          badge.removeAttribute('hidden');
        } else {
          badge.setAttribute('hidden', '');
        }
      })
      .catch(function () {});
  }

  ['cart:updated', 'cart:refresh', 'cart:added', 'product:added-to-cart'].forEach(function (evt) {
    document.addEventListener(evt, updateCartCount);
  });

  if (window.fetch) {
    var origFetch = window.fetch;
    window.fetch = function () {
      var args = arguments;
      var urlArg = args[0];
      var url = '';
      if (typeof urlArg === 'string') url = urlArg;
      else if (urlArg && urlArg.url) url = urlArg.url;
      var promise = origFetch.apply(this, args);
      if (
        url.indexOf('/cart/add') !== -1 ||
        url.indexOf('/cart/change') !== -1 ||
        url.indexOf('/cart/update') !== -1 ||
        url.indexOf('/cart/clear') !== -1
      ) {
        promise.then(function () { setTimeout(updateCartCount, 150); }).catch(function () {});
      }
      return promise;
    };
  }

  if (window.XMLHttpRequest) {
    var origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__kn_url = url || '';
      return origOpen.apply(this, arguments);
    };
    var origSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function () {
      var xhr = this;
      xhr.addEventListener('load', function () {
        var u = xhr.__kn_url || '';
        if (
          u.indexOf('/cart/add') !== -1 ||
          u.indexOf('/cart/change') !== -1 ||
          u.indexOf('/cart/update') !== -1 ||
          u.indexOf('/cart/clear') !== -1
        ) {
          setTimeout(updateCartCount, 150);
        }
      });
      return origSend.apply(this, arguments);
    };
  }

  setTimeout(updateCartCount, 500);

  // ============================================================
  // 2. GA4イベント計測 + 遷移先ページでの自動スクロール対応
  // ============================================================
  footer.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-kn-action]');
    if (!btn) return;
    var action = btn.getAttribute('data-kn-action');
    var pagePath = window.location.pathname + window.location.search;

    // 遷移先で自動スクロールが必要なボタン（カテゴリ・ブランド）
    if (action === 'category' || action === 'brand') {
      try {
        sessionStorage.setItem('kn_scroll_target', action);
      } catch (err) {}
    }

    if (typeof window.gtag === 'function') {
      window.gtag('event', 'sticky_footer_click', {
        action: action,
        page_path: pagePath,
        device: 'mobile'
      });
    }
    if (window.dataLayer && typeof window.dataLayer.push === 'function') {
      window.dataLayer.push({
        event: 'sticky_footer_click',
        sticky_action: action,
        page_path: pagePath,
        device: 'mobile'
      });
    }
  }, { passive: true });

  // ============================================================
  // 3. フッターから遷移してきた時、空白をスキップして自動スクロール
  // sessionStorageに目印があれば、ページ内の主要セクションへスクロール
  // ============================================================
  function autoScrollAfterNavigation() {
    var target;
    try {
      target = sessionStorage.getItem('kn_scroll_target');
    } catch (err) {
      return;
    }
    if (!target) return;

    // 目印を消す（次回以降は通常動作）
    try { sessionStorage.removeItem('kn_scroll_target'); } catch (err) {}

    // /pages/collections や /pages/ブランドコレクション 内でのみ動作
    var path = window.location.pathname;
    var isCollectionsPage = path.indexOf('/pages/collections') !== -1;
    var isBrandPage = path.indexOf('ブランド') !== -1 || path.indexOf('%E3%83%96%E3%83%A9%E3%83%B3%E3%83%89') !== -1;

    if (target === 'category' && !isCollectionsPage) return;
    if (target === 'brand' && !isBrandPage) return;

    // ページ内のメインコンテンツ要素を順に探して、見つかったらそこへスクロール
    function findScrollTarget() {
      var candidates = [
        // コレクション一覧の主要セクション
        '.collection',
        '.collection__list-container',
        '.collection__grid--item',
        // よくある見出しパターン
        'main h2',
        'main .sect-ttl',
        '.section-title',
        // コンテンツ領域の最初の意味のある要素
        '.page-wrap section',
        '.page-wrap .global__section',
        'main section'
      ];
      for (var i = 0; i < candidates.length; i++) {
        var el = document.querySelector(candidates[i]);
        if (el) {
          var rect = el.getBoundingClientRect();
          // 画面より下にある（=空白を超えた先にある）要素を優先
          if (rect.height > 0) return el;
        }
      }
      return null;
    }

    function performScroll() {
      var el = findScrollTarget();
      if (!el) return;
      var rect = el.getBoundingClientRect();
      // ヘッダーの高さ分を考慮してオフセット
      var headerOffset = 80;
      var scrollY = window.scrollY + rect.top - headerOffset;
      // 上のほうにスクロールする場合は何もしない（既に見えている）
      if (scrollY <= 50) return;
      window.scrollTo({
        top: scrollY,
        behavior: 'smooth'
      });
    }

    // ページの画像読み込み等を待ってからスクロール
    if (document.readyState === 'complete') {
      setTimeout(performScroll, 100);
    } else {
      window.addEventListener('load', function () {
        setTimeout(performScroll, 100);
      });
    }
  }

  autoScrollAfterNavigation();

})();